import {Loading} from "@shared/ui/Loading/Loading";
import {sessionStore} from "@services/session";
import {ReactNode} from "react";
import {runningGameStore} from "@services/runningGame/runningGame.store";
import {observer} from "mobx-react-lite";
import {useStoreLifecycle} from "@shared/hooks/useStoreLifecycle";

export const WithRunningGame = observer(({children}: {children: ReactNode}) => {

    const {isAuth} = sessionStore
    const {isLoading} = runningGameStore

    useStoreLifecycle(runningGameStore)

    if (isAuth && isLoading.value) {
        return <Loading/>
    }

    return children
})